"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("eventbrite_design_system/iconButton/IconButton"));

var _CrossChunky = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/CrossChunky"));

require("./Notification.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notification = function Notification(props) {
  var classes = (0, _classnames.default)('notification', _defineProperty({}, props.containerClasses, !!props.containerClasses));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: _objectSpread({}, props.containerStyles)
  }, !props.isNotDismissable && /*#__PURE__*/_react.default.createElement("div", {
    className: "notification__close"
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    iconType: /*#__PURE__*/_react.default.createElement(_CrossChunky.default, null),
    onClick: props.onClose,
    iconColor: "ui-500",
    title: "Close Event Notification"
  })), /*#__PURE__*/_react.default.createElement("section", {
    className: "notification__content"
  }, props.children));
};

Notification.propTypes = {
  children: _propTypes.default.node.isRequired,
  containerClasses: _propTypes.default.string,
  containerStyles: _propTypes.default.object
};
var _default = Notification;
exports.default = _default;
//# sourceMappingURL=Notification.js.map